import { DatePipe } from '@angular/common';
import { TranslatePipe } from '../../filters/translate.pipe';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Config from '../../utils/config.service';
import ModalService from '../../services/modal.service';
import ImageService from '../../services/image.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { VgCoreModule } from '@videogular/ngx-videogular/core';
import { VgControlsModule } from '@videogular/ngx-videogular/controls';
import { VgOverlayPlayModule } from '@videogular/ngx-videogular/overlay-play';
import { VgBufferingModule } from '@videogular/ngx-videogular/buffering';
import { ElementRef } from '@angular/core';

@Component({
	standalone: true,
	selector: 'modal-media',
	templateUrl: './modal-media.component.html',
	imports: [ CommonModule, DatePipe, TranslatePipe, FormsModule, VgCoreModule, VgControlsModule, VgOverlayPlayModule, VgBufferingModule ]
})
export class ModalMediaComponent implements OnInit {
	private config: Config = inject(Config);
	private modalService: ModalService = inject(ModalService);
	private imageService: ImageService = inject(ImageService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	private data = inject(MAT_DIALOG_DATA);
	
	vm: any = undefined;
	
	constructor(private elementRef: ElementRef) {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.initialized = false;
		this.vm.left = 0;
		this.vm.current = 0;
		
		Object.keys(this.data).forEach(key => this.vm[key] = this.data[key]);

		this.vm.handleModalClose = this.handleModalClose;
	}
	
	ngAfterViewInit() {
		setTimeout(() => {			
			var modalOpenData = { id: this.data.modalId, element: this.elementRef.nativeElement, chat: this.data.chat };
			this.angularBroadcastHelperService.rootBroadcast(this.config.getBroadcastConfig().Modal.MEDIA_OPEN, modalOpenData);
			this.handleModalInit(null, modalOpenData);
		}, 100);
	}

	ngOnDestroy() {
		this.angularBroadcastHelperService.rootBroadcast(
			this.config.getBroadcastConfig().Modal.MEDIA_CLOSING,
			{ id: this.data.modalId, chat: this.data.chat }
		);
		this.modalService.cleanUp(this.data.modalId);
	}
	
	handleVideoInit() {
		this.vm.video = {
			preload: 'auto',
			sources: [
				{ src: this.vm.media.fileUrl, type: 'video/mp4' }
			],
			theme: 'lib/videogular/videogular.min.css',
		};
		this.calculateVideoDimensions();
	}
	
	getViewportDimensions() {
		var height: any = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
		var width: any = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
		
		return { width: width, height: height };
	}
	
	calculateVideoDimensions() {
		var dim: any = this.getViewportDimensions();
		var h: any = dim.height;
		var w: any = dim.width;
		var headerRect: any = this.vm.element.querySelector('.c-modal__header').getBoundingClientRect();
		var buffer: any = headerRect.height + 20;
		
		if (w > 768) {
			this.vm.video.maxHeight = undefined;
			this.imageService.getDimensions(this.vm.media.thumbnailUrl).then((dimensions) => {
				if (!dimensions.width && !dimensions.height) {
					this.vm.video.maxWidth = 320;
				} else {
					var imgRatio: any = dimensions.width / dimensions.height;
					var winRatio: any = w / (h - buffer);
					if (imgRatio < winRatio) this.vm.video.maxWidth = Math.ceil((h - buffer) * imgRatio);
				}
			});
		} else {
			this.vm.video.maxWidth = undefined;
			this.vm.video.maxHeight = Math.ceil(dim.height - headerRect.height);
		}
		this.vm.initialized = true;
	}
	
	calculateBoundaries() {
		var rect: any = this.vm.element.querySelector('.c-modal__dialog').getBoundingClientRect();
		var dim: any = this.getViewportDimensions();
		var w: any = dim.width;
		var h: any = dim.height;
		this.vm.coordinates.minX = Math.ceil((rect.width - w) * 0.5);
		this.vm.coordinates.maxX = Math.floor((w - rect.width) * 0.5);
		this.vm.coordinates.minY = Math.ceil((rect.height - h) * 0.5);
		this.vm.coordinates.maxY = Math.floor((h - rect.height) * 0.5);
	}
	
	calculateCoordinates(evt?) {
		var x, y;
		if (evt) {
			var pageX: any = evt.pageX || ((evt.touches || [])[0] || {}).pageX || (((evt.originalEvent || {}).touches || [])[0] || {}).pageX;
			var pageY: any = evt.pageY || ((evt.touches || [])[0] || {}).pageY || (((evt.originalEvent || {}).touches || [])[0] || {}).pageY;
			x = (pageX || 0) - (this.vm.coordinates.startX || 0);
			y = (pageY || 0) - (this.vm.coordinates.startY || 0);
		} else {
			x = this.vm.coordinates.x;
			y = this.vm.coordinates.y;
		}
		this.vm.coordinates.x = Math.max(this.vm.coordinates.minX, Math.min(x, this.vm.coordinates.maxX));
		this.vm.coordinates.y = Math.max(this.vm.coordinates.minY, Math.min(y, this.vm.coordinates.maxY));
	}
	
	handleModalInit(e, data) {
		var id: any = data.id;
		var element: any = data.element;
		if (id !== this.vm.modalId) return;
		
		this.vm.element = element;
		this.vm.coordinates = {
			startX: 0,
			startY: 0,
			x: 0,
			y: 0,
		};
		this.vm.canvas = {};
		
		this.angularHelperService.element(this.vm.element).on('mousedown.' + id, (evt) => { this.handleSetOnTop(evt); });
		this.angularHelperService.element(this.angularHelperService.getWindow()).on('resize.' + id, () => { this.handleWindowResize(); });
		
		if (this.vm.media.postType === 'VIDEO') this.handleVideoInit();
	}
	
	handleWindowResize() {
		this.calculateBoundaries();
		//this.angularStateHelperService.scopeApply(this, () => {
		setTimeout(() => {
			this.calculateCoordinates();
			if (this.vm.video) this.calculateVideoDimensions();
		}, 200);
		//});
	}
	
	handleSetOnTop(evt) {
		this.angularHelperService.createTimer(() => {
			this.modalService.setOnTop(this.vm.modalId);
		}, 50);
	}
	
	handleModalClose() {
		this.modalService.close(this.vm.modalId);
	}
	
}